import React from 'react';
import { COPYRIGHT_TEXT } from '../data/common';

const Footer: React.FC = () => {
  return (
    <footer className="page-footer">
      <p className="copyright-text">
        {COPYRIGHT_TEXT}
      </p>
    </footer>
  );
};

export default Footer;
